var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInformationInfo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.15669 7.15606 0 16 0C24.8433 0 32 7.15606 32 16C32 24.8433 24.8439 32 16 32C7.15669 32 0 24.8439 0 16ZM2.5 16C2.5 23.4616 8.53794 29.5 16 29.5C23.4615 29.5 29.5 23.4621 29.5 16C29.5 8.53844 23.4621 2.5 16 2.5C8.53844 2.5 2.5 8.53794 2.5 16Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M16 13.3965C15.3096 13.3965 14.75 13.9561 14.75 14.6465V22.696C14.75 23.3864 15.3096 23.946 16 23.946C16.6904 23.946 17.25 23.3864 17.25 22.696V14.6465C17.25 13.9561 16.6904 13.3965 16 13.3965Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16,
    cy: 10.1777,
    r: 1.6875,
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInformationInfo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/informationInfo.bc5196df105a536b15965a61bd1d6b7d.svg";